var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdateCircleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 32 32"
    },
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 12c-.3 0-.5-.1-.7-.3l-4-4c-.4-.4-.4-1 0-1.4l4-4c.4-.4 1-.4 1.4 0s.4 1 0 1.4L14.4 7l3.3 3.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 30C9.4 30 4 24.6 4 18c0-3 1.1-5.9 3.2-8.1.4-.4 1-.4 1.4-.1.4.4.4 1 .1 1.4C6.9 13.1 6 15.5 6 18c0 5.5 4.5 10 10 10s10-4.5 10-10S21.5 8 16 8h-1c-.6 0-1-.4-1-1s.4-1 1-1h1c6.6 0 12 5.4 12 12s-5.4 12-12 12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateCircleArrow);
export default __webpack_public_path__ + "static/media/updateCircleArrow.a9dffce8de4eacb394bcac4c4d7b7e33.svg";
export { ForwardRef as ReactComponent };